module.exports = __webpack_public_path__ + "static/media/mov-simple-icon.8e85c041.svg";